<template lang="pug">
div.loyalty-template-conf
  h1.loyalty-template-conf__title {{ $t('loyalty.configuration') }}
  h2.loyalty-template-conf__subtitle {{ $t('loyalty.valueType') }}
  span(v-html="addState(data.tip_cupon)").loyalty-template-conf__data
  div.loyalty-template-conf__espaciado
  h2.loyalty-template-conf__subtitle {{ $t('loyalty.discountvalue') }}
  span.loyalty-template-conf__data {{ data.imp_bonif }}
  div.loyalty-template-conf__espaciado
  h2.loyalty-template-conf__subtitle {{ $t('loyalty.chanelUse') }}
  span.loyalty-template-conf__data {{ data.desc_canal || $t('loyalty.noData') }}
  div.loyalty-template-conf__espaciado
  h2.loyalty-template-conf__subtitle {{ $t('loyalty.minImp') }}
  span.loyalty-template-conf__data {{ data.imp_minimo }}
  div.loyalty-template-conf__espaciado
  h2.loyalty-template-conf__subtitle {{ $t('loyalty.maxBon') }}
  span.loyalty-template-conf__data {{ data.imp_max_bonif }}
  div.loyalty-template-conf__espaciado
  h2.loyalty-template-conf__subtitle {{ $t('loyalty.maxCoupons') }}
  span.loyalty-template-conf__data {{ data.num_max_cup }}
  div.loyalty-template-conf__espaciado
  h2.loyalty-template-conf__subtitle {{ $t('loyalty.tranferCoupon') }}
  span.loyalty-template-conf__data {{ data.traspaso || $t('loyalty.noData') }}
  div.loyalty-template-conf__espaciado
  h2.loyalty-template-conf__subtitle {{ $t('loyalty.defaultState') }}
  span.loyalty-template-conf__data {{ data.ind_activo || $t('loyalty.noData') }}
  div.loyalty-template-conf__espaciado
</template>
<script>
export default {
  props: {
    data: {
      type: Object
    }
  },
  name: 'DatosPlantilla',
  methods: {
    addState (data) {
      if (data === '01') {
        return `<span>${this.$t('loyalty.Percentage')}</span>`
      } else if (data === '02') {
        return `<span>${this.$t('loyalty.Permanent')}</span>`
      } else {
        return `<span>${this.$t('loyalty.noData')}</span>`
      }
    }
  }
}
</script>
<style lang="scss">
.loyalty-template-conf{
  .ods-module__body{
    padding: 0;
  }
  &__espaciado{
  padding-bottom: rem(24);
  }
  &__data{
   padding-left: rem(32);
   font-size: rem(12);
   line-height: rem(24);
  }

  &__title{
    font-size: rem(14);
    line-height: rem(24);
    margin-bottom: rem(16);
    margin-left: rem(32);
    margin-top: rem(32);
    font-weight: 500;
  }

  &__subtitle{
    font-size: rem(9);
    line-height: rem(16);
    margin-bottom: rem(8);
    text-transform: uppercase;
    color: #6E767D;
    font-weight: 400;
    margin-left: rem(32);
  }
}
</style>
